import { useState, useEffect, useMemo } from "react";

import orionAPI from "../config/orionAPI";
import { formatNumber, formatDate } from "./useOpenStrategies";

export const formatRankingPercentage = (value) => `+${formatNumber(value, 2)}%`;

const useOpenTradesRanking = () => {
  const [rawOpenTradesRanking, setRawOpenTradesRanking] = useState([]);
  const [loadingOpenTradesRanking, setLoadingOpenTradesRanking] =
    useState(true);

  const openTradesRanking = useMemo(() => {
    if (!rawOpenTradesRanking.length) return [];

    return rawOpenTradesRanking.map((trade) => {
      const profitValue = Number(trade.partial_profit) || 0;

      return {
        ...trade,
        formatted: {
          profit: formatRankingPercentage(profitValue),
          profitNumber: profitValue,
          purchaseDate: formatDate(trade.purchase_date),
        },
      };
    });
  }, [rawOpenTradesRanking]);

  const fetchOpenTradesRanking = async () => {
    setLoadingOpenTradesRanking(true);
    await orionAPI
      .get("/api/public/open_trades/ranking")
      .then((response) => {
        setRawOpenTradesRanking(response.data);
        setLoadingOpenTradesRanking(false);
      })
      .catch((error) => {
        console.error(error);
        setLoadingOpenTradesRanking(false);
      });
  };

  useEffect(() => {
    fetchOpenTradesRanking();
  }, []);

  return {
    openTradesRanking,
    loadingOpenTradesRanking,
  };
};

export default useOpenTradesRanking;
